import React from "react";

import type { RebookFlightSliceProps } from "./types";

export const useRebookFlightSlice = ({
  direction,
  slice,
  segments,
  travelersCount,
  airlines,
  airports,
}: RebookFlightSliceProps) => {
  const lastSegment = React.useMemo(
    () => slice.segments[slice.segments.length - 1],
    [slice]
  );
  const destinationCode = lastSegment.destination.locationCode;
  const destinationName =
    airports[destinationCode]?.cityName ?? destinationCode;

  return React.useMemo(
    () => ({
      text: {
        destinationName,
        destinationCode,
      },
      context: {
        airports,
        airlines,
        direction,
        slice,
        segments,
        travelersCount,
      },
    }),
    [
      airlines,
      airports,
      destinationCode,
      destinationName,
      direction,
      segments,
      slice,
      travelersCount,
    ]
  );
};
